import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { approvals as approvalsApi } from '../../api/endpoints';
import type { Tokens } from '../../theme/tokens';

// The top-bar 🔔: how many approval requests are waiting for the signed-in
// user. Refreshes every minute, and at once after a decision (the inbox fires
// "approvals-changed"). Opens the inbox.

const REFRESH_MS = 60_000;

const ApprovalsBell = ({ t, style }: { t: Tokens; style?: React.CSSProperties }) => {
  const navigate = useNavigate();
  const [waiting, setWaiting] = useState(0);

  useEffect(() => {
    let alive = true;
    const refresh = () => approvalsApi.count()
      .then((c) => { if (alive) setWaiting(Number(c?.waiting) || 0); })
      .catch(() => { /* the bell is a convenience; stay quiet */ });
    refresh();
    const timer = window.setInterval(refresh, REFRESH_MS);
    // After a decision, or a save that opened a request.
    window.addEventListener('approvals-changed', refresh);
    window.addEventListener('approval-notice', refresh);
    return () => {
      alive = false;
      window.clearInterval(timer);
      window.removeEventListener('approvals-changed', refresh);
      window.removeEventListener('approval-notice', refresh);
    };
  }, []);

  return (
    <button
      type="button"
      style={{ ...style, position: 'relative' }}
      onClick={() => navigate('/approvals')}
      title={waiting ? `${waiting} approval request(s) waiting for you` : 'Approvals'}
    >
      🔔 Approvals
      {waiting > 0 && (
        <span style={{
          marginLeft: '6px', minWidth: '20px', padding: '1px 6px', borderRadius: '10px',
          backgroundColor: t.danger, color: '#FFF', fontSize: t.fontSize.xs, fontWeight: 'bold'
        }}>
          {waiting}
        </span>
      )}
    </button>
  );
};

export default ApprovalsBell;
